import { Maximize2, Minus, Plus, RotateCcw } from "lucide-react";
import * as React from "react";
import { Button } from "@/components/ui/button";

export function CanvasControls({
  scale,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  onFitView,
}: {
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  onFitView: () => void;
}) {
  return (
    <div
      aria-label="Canvas controls"
      className="absolute bottom-4 left-4 z-30 flex items-center gap-1 rounded-lg border bg-card/90 p-1 shadow-md backdrop-blur-sm"
    >
      <Button
        variant="ghost"
        size="icon"
        className="size-8 text-foreground"
        title="Zoom in (+)"
        aria-label="Zoom in"
        onClick={onZoomIn}
      >
        <Plus className="size-4" aria-hidden="true" />
      </Button>

      <span className="min-w-12 text-center text-xs font-semibold tabular-nums text-muted-foreground select-none">
        {Math.round(scale * 100)}%
      </span>

      <Button
        variant="ghost"
        size="icon"
        className="size-8 text-foreground"
        title="Zoom out (-)"
        aria-label="Zoom out"
        onClick={onZoomOut}
      >
        <Minus className="size-4" aria-hidden="true" />
      </Button>

      <div className="mx-0.5 h-4 w-px bg-border" aria-hidden="true" />

      <Button
        variant="ghost"
        size="icon"
        className="size-8 text-foreground"
        title="Reset zoom to 100%"
        aria-label="Reset zoom"
        onClick={onResetZoom}
      >
        <RotateCcw className="size-3.5" aria-hidden="true" />
      </Button>

      <Button
        variant="ghost"
        size="icon"
        className="size-8 text-foreground"
        title="Fit all nodes to view"
        aria-label="Fit view"
        onClick={onFitView}
      >
        <Maximize2 className="size-3.5" aria-hidden="true" />
      </Button>
    </div>
  );
}
